import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { OrganizationConfigService } from '../../../../../../../../../services/organization-config/organization-config.service';
import { CustomerMembership, CustomerMembershipCustomer } from '../../../../../../../../../models/membership';
import { SelectCustomerModalComponent } from '../../../../../../modals/select-customer-modal/select-customer-modal.component';
import { CustomerSearchResult } from '../../../../../../../../../models/customer';

@Component({
  selector: 'app-edit-group-membership-members-immediately',
  templateUrl: './edit-group-membership-members-immediately.component.html',
  styleUrls: ['./edit-group-membership-members-immediately.component.css']
})
export class EditGroupMembershipMembersImmediatelyComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public members: CustomerMembershipCustomer[];

  public errorMessage = '';

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfig: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    this.members = [];
    for (const member of this.membership.all_customers) {
      this.members.push({...member});
    }
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public openAddMemberModal() {
    const modalRef = this.modalService.open(SelectCustomerModalComponent);
    modalRef.componentInstance.excludeCustomerIds = this.members.map(cmc => cmc.id);
    modalRef.componentInstance.submitCallback = (result: CustomerSearchResult) => {
      this.members.push({
        id: result.id,
        member_id: null,
        is_individually_frozen: false,
        is_pending_addition: false,
        is_pending_removal: false,
        member_freeze_date: null,
        member_unfreeze_date: null,
        first_name: result.first_name,
        last_name: result.last_name
      });
    };
  }

  private handleSave() {
    this.errorMessage = '';

    if (this.membership.unlinked_customers.length > 0) {
      this.errorMessage = 'Membership has unlinked members.';
      return;
    }

    this.loadingEvent.emit(true);

    this.customerService
      .editGroupMembershipMembersImmediately(this.membership, this.members.map(cmc => cmc.id))
      .then(() => {
        this.savedCallback('Members edited successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this membership\'s members.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
